import { PUT_CARD_APPLY_ERROR, PUT_CARD_APPLY_START, PUT_CARD_APPLY_SUCCESS } from '../../types';

export default function put_card_apply(state, action) {
  switch (action.type) {
    case PUT_CARD_APPLY_START:
      return { ...state };
    case PUT_CARD_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_CARD_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}